// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import * as Papa from 'papaparse';
import uuid from 'uuid';

import PopupContent from '../PopupContent';
import styles from './createUsersDrag.css';
import * as userAction from '../../actions/users';


type CreateUsersDragPropTypes = {
  uploadUsers: Function,
  clearUploading: Function,
};

class CreateUsersDrag extends Component<CreateUsersDragPropTypes> {
  onDrop(files) {
    const { clearUploading } = this.props || {};
    clearUploading();
    if (files.length) {
      Papa.parse(files[0], {
        header: true,
        skipEmptyLines: true,
        complete: results => this.generateEntities(results.data),
      });
    }
  }

  typeSwitch = (type: string) => ({
    estudiante: 'student',
    monitor: 'monitor',
    chofer: 'driver',
    padre: 'parent',
  })[type]

  generateEntities(data) {
    const { uploadUsers } = this.props || {};
    const byId = {};
    const order = [];
    data.forEach(
      ({
        id,
        tipo,
        nombre,
        email,
      }: Object) => {
        byId[id] = {
          id: uuid(),
          tipo: this.typeSwitch(tipo),
          complete: !!(nombre && email),
        };

        order.push(id);
      },
    );
    uploadUsers(byId, order);
  }

  render() {
    return (
      <PopupContent>
        <div className={styles.dropContainer}>
          <Dropzone
            onDrop={this.onDrop.bind(this)}
            accept="text/csv"
            className={styles.dropzone}
            acceptClassName={styles.accept}
            rejectClassName={styles.reject}
            activeClassName={
              `
                ${styles.dropzone}
                ${styles.dropzoneActive}
              `
            }
          >
            <div className={styles.holder}>
              { 'Arrastra el archivo CSV acá...' }
            </div>

          </Dropzone>
        </div>
      </PopupContent>
    );
  }
}

export default connect(
  undefined,
  dispatch => ({
    uploadUsers(byId, order) {
      dispatch(userAction.addUploadingUsers(byId, order));
      dispatch(userAction.updateCreateUsersStep(3));
    },
    clearUploading() {
      dispatch(userAction.clearUploadingUsers());
    },
  }),
)(CreateUsersDrag);



// WEBPACK FOOTER //
// ./src/scripts/components/CreateUsersDrag/index.jsx